const debounce = (callback: (...args: []) => void, delay: number) => {
  let tid: NodeJS.Timeout;
  return function (...args: []) {
    const ctx = self;
    tid && clearTimeout(tid);
    tid = setTimeout(() => {
      callback.apply(ctx, args);
    }, delay);
  };
};

const ResizeObserver = window.ResizeObserver || class {}; // Mock básico caso não exista
export class FixedResizeObserver extends ResizeObserver {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(callback: (...args: any[]) => void) {
    callback = debounce(callback, 20);
    super(callback);
  }
}